module.exports = __webpack_public_path__ + "konsultacje-spoleczne-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/konsultacje-spoleczne-logo.png
// module id = 1543
// module chunks = 0